/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Gate_IntroInputs */

const tr_mascot_chat_gate_intro = /** @type {(inputs: Mascot_Chat_Gate_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba! Sana yardımcı olabilmem için önce kısa bir bilgi alalım. Adın ve e-postan, sohbet sırasında çevrimdışı olursan yanıtı sana iletebilmemiz için.`)
};

const en_mascot_chat_gate_intro = /** @type {(inputs: Mascot_Chat_Gate_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi! To help you better, we just need a few details first. Your name and email allow us to get back to you if you go offline during the chat.`)
};

const de_mascot_chat_gate_intro = /** @type {(inputs: Mascot_Chat_Gate_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo! Damit ich dir helfen kann, benötigen wir vorab ein paar Infos. Deinen Namen und deine E-Mail brauchen wir, um dir antworten zu können, falls du während des Chats offline gehst.`)
};

const ru_mascot_chat_gate_intro = /** @type {(inputs: Mascot_Chat_Gate_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет! Чтобы я мог помочь, мне нужно немного информации. Ваше имя и e-mail нужны, чтобы мы могли отправить ответ, если вы уйдете в офлайн во время чата.`)
};

/**
* | output |
* | --- |
* | "Hi! To help you better, we just need a few details first. Your name and email allow us to get back to you if you go offline during the chat." |
*
* @param {Mascot_Chat_Gate_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_gate_intro = /** @type {((inputs?: Mascot_Chat_Gate_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Gate_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_gate_intro(inputs)
	if (locale === "de") return de_mascot_chat_gate_intro(inputs)
	if (locale === "ru") return ru_mascot_chat_gate_intro(inputs)
	return tr_mascot_chat_gate_intro(inputs)
});